/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ when: NonNullable<unknown> }} Outcomeformsummaryrefused3Inputs */

const en_outcomeformsummaryrefused3 = /** @type {(inputs: Outcomeformsummaryrefused3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Contractor refused on ${i?.when}`)
};

const pt_outcomeformsummaryrefused3 = /** @type {(inputs: Outcomeformsummaryrefused3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Empreiteiro recusou em ${i?.when}`)
};

/**
* | output |
* | --- |
* | "Contractor refused on {when}" |
*
* @param {Outcomeformsummaryrefused3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const outcomeformsummaryrefused3 = /** @type {((inputs: Outcomeformsummaryrefused3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Outcomeformsummaryrefused3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_outcomeformsummaryrefused3(inputs)
	return pt_outcomeformsummaryrefused3(inputs)
});
export { outcomeformsummaryrefused3 as "outcomeFormSummaryRefused" }